import type { Anime, AnimeCategory } from "@/types/anime";

export const animeList: Anime[] = [
  {
    id: "anime-01",
    title: "炽焰少年",
    cover:
      "https://readdy.ai/api/search-image?query=dynamic%20anime%20teenage%20boy%20with%20spiky%20fiery%20orange%20hair%20surrounded%20by%20blazing%20flames%2C%20fierce%20determined%20eyes%2C%20energetic%20shonen%20battle%20style%2C%20vibrant%20saturated%20colors%2C%20simple%20warm%20gradient%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20key%20visual%20of%20fiery%20hero%20facing%20giant%20flames%2C%20dramatic%20cinematic%20composition%2C%20orange%20and%20red%20tones%2C%20dark%20vignette%20edges%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=anime-hero-01&orientation=landscape",
    category: "热血",
    region: "日本",
    year: 2023,
    status: "连载",
    rating: 9.4,
    heat: 98600,
    episodes: 24,
    updatedAt: "2026-10-12",
    summary:
      "平凡少年在一次意外中获得炽焰之力，为了守护同伴踏上修炼之路。热血与羁绊交织的成长故事，战斗场面张力十足。",
    tags: ["热血", "战斗", "成长"],
  },
  {
    id: "anime-02",
    title: "星海远征",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20space%20explorer%20in%20sleek%20white%20and%20blue%20suit%20standing%20before%20a%20giant%20glowing%20planet%20and%20starfield%2C%20cinematic%20sci-fi%2C%20cool%20tones%2C%20simple%20deep%20space%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20sci-fi%20key%20visual%20of%20spaceship%20flying%20toward%20glowing%20nebula%2C%20cinematic%20deep%20space%20composition%2C%20cool%20blue%20tones%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-02&orientation=landscape",
    category: "科幻",
    region: "日本",
    year: 2022,
    status: "完结",
    rating: 9.1,
    heat: 87200,
    episodes: 26,
    updatedAt: "2026-10-10",
    summary:
      "人类踏入深空殖民时代，一支远征舰队穿越星门寻找新家园。宏大的宇宙观与细腻的人物情感，科幻迷必看之作。",
    tags: ["科幻", "宇宙", "冒险"],
  },
  {
    id: "anime-03",
    title: "樱花之约",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20high%20school%20girl%20and%20boy%20under%20blooming%20pink%20cherry%20blossom%20trees%2C%20tender%20romantic%20mood%2C%20soft%20pastel%20colors%2C%20simple%20bright%20sky%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20romantic%20key%20visual%20of%20couple%20under%20cherry%20blossom%20avenue%2C%20cinematic%20soft%20pastel%20composition%2C%20warm%20light%2C%20gentle%20atmosphere&width=1600&height=900&seq=anime-hero-03&orientation=landscape",
    category: "恋爱",
    region: "日本",
    year: 2021,
    status: "完结",
    rating: 8.9,
    heat: 76400,
    episodes: 13,
    updatedAt: "2026-10-08",
    summary:
      "转学生与原班长在樱花树下许下约定，一年四季的青春校园里，两人逐渐靠近。细腻治愈的纯爱日常。",
    tags: ["恋爱", "校园", "治愈"],
  },
  {
    id: "anime-04",
    title: "千剑传说",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20warrior%20wielding%20a%20glowing%20ancient%20sword%20in%20misty%20mountain%20landscape%2C%20chinese%20fantasy%20guofeng%20style%2C%20dramatic%20lighting%2C%20simple%20ink-wash%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20chinese%20fantasy%20anime%20key%20visual%20of%20warrior%20with%20glowing%20sword%20in%20misty%20mountains%2C%20cinematic%2C%20dramatic%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-04&orientation=landscape",
    category: "奇幻",
    region: "中国",
    year: 2023,
    status: "连载",
    rating: 9.2,
    heat: 91300,
    episodes: 20,
    updatedAt: "2026-10-12",
    summary:
      "剑宗弟子背负失落的千剑之名，踏上寻找上古剑灵之路。国风美术与东方奇幻设定，画面气韵生动。",
    tags: ["奇幻", "国风", "战斗"],
  },
  {
    id: "anime-05",
    title: "深夜食堂物语",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20anime%20small%20restaurant%20at%20night%20with%20warm%20lantern%20light%20and%20a%20kind%20chef%2C%20slice%20of%20life%2C%20soft%20warm%20colors%2C%20simple%20dark%20street%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20slice%20of%20life%20key%20visual%20of%20cozy%20late%20night%20diner%20lanterns%2C%20cinematic%20warm%20glow%2C%20gentle%20atmosphere&width=1600&height=900&seq=anime-hero-05&orientation=landscape",
    category: "日常",
    region: "日本",
    year: 2020,
    status: "完结",
    rating: 8.7,
    heat: 58200,
    episodes: 12,
    updatedAt: "2026-10-05",
    summary:
      "城市深夜的一角，小小食堂里每一道菜都藏着一位客人的故事。温暖治愈，适合睡前小酌般的观感。",
    tags: ["日常", "治愈", "美食"],
  },
  {
    id: "anime-06",
    title: "篮球之魂",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20basketball%20player%20soaring%20mid-air%20for%20a%20powerful%20dunk%2C%20dynamic%20action%20pose%2C%20sporty%20energy%2C%20vibrant%20colors%2C%20simple%20gym%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20sports%20key%20visual%20of%20basketball%20match%20with%20glowing%20court%2C%20cinematic%20dynamic%20composition%2C%20warm%20lighting&width=1600&height=900&seq=anime-hero-06&orientation=landscape",
    category: "运动",
    region: "日本",
    year: 2019,
    status: "完结",
    rating: 9.0,
    heat: 72100,
    episodes: 25,
    updatedAt: "2026-10-02",
    summary:
      "一群被看轻的少年，为了全国大赛的梦想组建篮球队。汗水、默契与逆转，把运动的燃点做到极致。",
    tags: ["运动", "热血", "青春"],
  },
  {
    id: "anime-07",
    title: "迷雾侦探",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20detective%20in%20long%20coat%20standing%20in%20foggy%20rainy%20city%20street%20at%20night%2C%20mysterious%20noir%20mood%2C%20moody%20cool%20colors%2C%20simple%20misty%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20mystery%20key%20visual%20of%20rainy%20neon%20city%20street%20with%20detective%20silhouette%2C%20cinematic%20noir%2C%20cool%20tones%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-07&orientation=landscape",
    category: "悬疑",
    region: "日本",
    year: 2022,
    status: "连载",
    rating: 8.8,
    heat: 64300,
    episodes: 18,
    updatedAt: "2026-10-11",
    summary:
      "浓雾笼罩的城市里接连发生离奇案件，一位不愿透露姓名的侦探循着线索步步逼近真相。氛围感拉满。",
    tags: ["悬疑", "推理", "都市"],
  },
  {
    id: "anime-08",
    title: "机甲纪元",
    cover:
      "https://readdy.ai/api/search-image?query=giant%20anime%20mecha%20robot%20standing%20in%20ruined%20battlefield%2C%20glowing%20blue%20energy%20core%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20simple%20smoky%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20mecha%20key%20visual%20standing%20in%20glowing%20battlefield%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-08&orientation=landscape",
    category: "机战",
    region: "日本",
    year: 2021,
    status: "连载",
    rating: 9.3,
    heat: 89900,
    episodes: 22,
    updatedAt: "2026-10-12",
    summary:
      "少年驾驶员与传说中的机甲签订了契约，在战争的洪流中寻找和平的可能。硬核机设与宏大战场，视觉冲击强烈。",
    tags: ["机战", "科幻", "战争"],
  },
  {
    id: "anime-09",
    title: "龙猫之森",
    cover:
      "https://readdy.ai/api/search-image?query=whimsical%20anime%20forest%20spirit%20creature%20in%20a%20lush%20green%20magical%20forest%2C%20nostalgic%20classic%20animation%20style%2C%20warm%20gentle%20colors%2C%20simple%20green%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20key%20visual%20of%20enchanted%20lush%20forest%20with%20gentle%20spirits%2C%20cinematic%20nostalgic%20warm%20tones%2C%20dreamy%20atmosphere&width=1600&height=900&seq=anime-hero-09&orientation=landscape",
    category: "经典",
    region: "日本",
    year: 1988,
    status: "完结",
    rating: 9.7,
    heat: 102400,
    episodes: 1,
    updatedAt: "2026-09-28",
    summary:
      "两个小女孩搬到乡下，遇见了森林里的神奇生物。跨越时代的童年回忆，温柔得让人想哭的经典之作。",
    tags: ["经典", "治愈", "奇幻"],
  },
  {
    id: "anime-10",
    title: "都市异闻录",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20urban%20fantasy%20girl%20with%20glowing%20magical%20runes%20in%20modern%20city%20night%2C%20mysterious%20atmosphere%2C%20neon%20and%20dark%20tones%2C%20simple%20city%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20urban%20fantasy%20key%20visual%20of%20magic%20runes%20over%20modern%20city%20skyline%20at%20night%2C%20cinematic%2C%20dark%20neon%20edges&width=1600&height=900&seq=anime-hero-10&orientation=landscape",
    category: "奇幻",
    region: "中国",
    year: 2023,
    status: "连载",
    rating: 8.6,
    heat: 60100,
    episodes: 16,
    updatedAt: "2026-10-09",
    summary:
      "在繁华都市的夹缝中，隐藏着不为人知的异界传说。一位能看见符文的高中生卷入其中，揭开城市另一面。",
    tags: ["奇幻", "都市", "悬疑"],
  },
  {
    id: "anime-11",
    title: "排球梦想",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20volleyball%20player%20spiking%20the%20ball%20with%20intense%20focus%2C%20teammates%20blurred%20behind%2C%20energetic%20sports%20action%2C%20bright%20colors%2C%20simple%20court%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20volleyball%20key%20visual%20in%20bright%20gymnasium%2C%20cinematic%20action%20composition%2C%20warm%20lighting%2C%20dynamic%20energy&width=1600&height=900&seq=anime-hero-11&orientation=landscape",
    category: "运动",
    region: "日本",
    year: 2018,
    status: "完结",
    rating: 8.9,
    heat: 66700,
    episodes: 25,
    updatedAt: "2026-09-30",
    summary:
      "身高不占优势的少年凭借惊人的弹跳力加入排球部，与队友一起挑战强敌。每一个扣杀都让人热血沸腾。",
    tags: ["运动", "热血", "团队"],
  },
  {
    id: "anime-12",
    title: "魔法学院日记",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20magic%20academy%20student%20casting%20glowing%20spells%20in%20grand%20old%20library%2C%20whimsical%20fantasy%2C%20warm%20magical%20lighting%2C%20simple%20ornate%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-12&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20magic%20academy%20key%20visual%20of%20grand%20floating%20castle%20school%2C%20cinematic%20whimsical%20composition%2C%20warm%20magical%20light&width=1600&height=900&seq=anime-hero-12&orientation=landscape",
    category: "校园",
    region: "日本",
    year: 2022,
    status: "连载",
    rating: 8.5,
    heat: 55900,
    episodes: 20,
    updatedAt: "2026-10-07",
    summary:
      "普通少女意外考入神秘的魔法学院，在课堂上与伙伴们一同学习咒语、解开学院尘封的秘密。轻松又奇妙的校园幻想。",
    tags: ["校园", "奇幻", "日常"],
  },
  {
    id: "anime-13",
    title: "太空牛仔",
    cover:
      "https://readdy.ai/api/search-image?query=western%20anime%20space%20bounty%20hunter%20with%20laser%20revolver%20in%20front%20of%20starship%2C%20retro%20sci-fi%20western%20fusion%2C%20bold%20colors%2C%20simple%20desert%20planet%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-13&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20space%20western%20key%20visual%20of%20bounty%20hunter%20on%20desert%20planet%20with%20two%20suns%2C%20cinematic%2C%20bold%20warm%20tones%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-13&orientation=landscape",
    category: "科幻",
    region: "美国",
    year: 2020,
    status: "完结",
    rating: 8.4,
    heat: 47300,
    episodes: 12,
    updatedAt: "2026-09-26",
    summary:
      "在星际边境的荒凉星球上，一名独来独往的赏金猎人接下了改变命运的一单。复古西部与太空歌剧的奇妙混搭。",
    tags: ["科幻", "冒险", "西部"],
  },
  {
    id: "anime-14",
    title: "剑舞长歌",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20swordswoman%20dancing%20with%20twin%20blades%20surrounded%20by%20swirling%20petals%20and%20energy%2C%20elegant%20dynamic%20pose%2C%20chinese%20fantasy%20style%2C%20simple%20dramatic%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-14&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20key%20visual%20of%20swordswoman%20with%20swirling%20petals%20energy%2C%20cinematic%2C%20warm%20dramatic%20composition%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-14&orientation=landscape",
    category: "热血",
    region: "中国",
    year: 2024,
    status: "连载",
    rating: 9.5,
    heat: 94100,
    episodes: 15,
    updatedAt: "2026-10-12",
    summary:
      "江湖纷乱，一位少女以双剑之名行走天下，为查明师门血案一路斩荆披棘。打戏行云流水，年度热血国创。",
    tags: ["热血", "国风", "武侠"],
  },
  {
    id: "anime-15",
    title: "咖啡厅的午后",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20girl%20enjoying%20coffee%20in%20a%20sunny%20cozy%20cafe%20by%20the%20window%2C%20relaxed%20slice%20of%20life%2C%20soft%20warm%20colors%2C%20simple%20window%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-15&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20slice%20of%20life%20key%20visual%20of%20sunny%20cozy%20cafe%20interior%2C%20cinematic%20soft%20warm%20light%2C%20peaceful%20atmosphere&width=1600&height=900&seq=anime-hero-15&orientation=landscape",
    category: "日常",
    region: "日本",
    year: 2023,
    status: "完结",
    rating: 8.3,
    heat: 41200,
    episodes: 12,
    updatedAt: "2026-10-04",
    summary:
      "都市白领在午休时间光顾的街角咖啡厅，每一天都有不同的小故事发生。温柔慢节奏，适合放松心情。",
    tags: ["日常", "治愈", "美食"],
  },
  {
    id: "anime-16",
    title: "幻境传说",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20adventurer%20standing%20in%20a%20magical%20floating%20island%20realm%20with%20glowing%20crystals%2C%20epic%20fantasy%2C%20vibrant%20colors%2C%20simple%20dreamy%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-16&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20fantasy%20key%20visual%20of%20floating%20islands%20and%20glowing%20crystals%2C%20cinematic%20dreamy%20composition%2C%20vibrant%20colors&width=1600&height=900&seq=anime-hero-16&orientation=landscape",
    category: "奇幻",
    region: "日本",
    year: 2019,
    status: "完结",
    rating: 8.8,
    heat: 63400,
    episodes: 24,
    updatedAt: "2026-09-24",
    summary:
      "浮空列岛之上，勇者为了唤醒沉睡的守护龙而展开冒险。宏大的世界观设定与唯美的幻想美术。",
    tags: ["奇幻", "冒险", "史诗"],
  },
  {
    id: "anime-17",
    title: "钢铁之心",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20pilot%20in%20sleek%20futuristic%20cockpit%20controlling%20a%20mecha%2C%20intense%20sci-fi%20action%2C%20mechanical%20detail%2C%20cool%20colors%2C%20simple%20metallic%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-17&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20mecha%20pilot%20key%20visual%20inside%20glowing%20futuristic%20cockpit%2C%20cinematic%20mechanical%20detail%2C%20cool%20tones%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-17&orientation=landscape",
    category: "机战",
    region: "日本",
    year: 2024,
    status: "连载",
    rating: 9.1,
    heat: 82700,
    episodes: 18,
    updatedAt: "2026-10-11",
    summary:
      "天才少年工程师打造出属于自己的机甲，与AI搭档并肩作战。紧凑的机甲战斗与人性探讨双线并进。",
    tags: ["机战", "科幻", "热血"],
  },
  {
    id: "anime-18",
    title: "青春纪事",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20high%20school%20students%20laughing%20on%20rooftop%20at%20golden%20sunset%2C%20nostalgic%20youth%20drama%2C%20warm%20golden%20colors%2C%20simple%20sky%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-18&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20youth%20key%20visual%20of%20students%20on%20rooftop%20at%20golden%20sunset%2C%20cinematic%20nostalgic%20warm%20tones&width=1600&height=900&seq=anime-hero-18&orientation=landscape",
    category: "校园",
    region: "日本",
    year: 2017,
    status: "完结",
    rating: 8.5,
    heat: 48900,
    episodes: 12,
    updatedAt: "2026-09-20",
    summary:
      "毕业季来临，几位挚友在天台上许下未来之约。关于青春、梦想与离别的温柔群像剧。",
    tags: ["校园", "青春", "治愈"],
  },
  {
    id: "anime-19",
    title: "深海之谜",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20diver%20descending%20into%20glowing%20deep%20ocean%20abyss%20with%20mysterious%20creatures%2C%20eerie%20underwater%20mood%2C%20deep%20blue%20teal%20tones%2C%20simple%20dark%20water%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-19&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20deep%20sea%20key%20visual%20of%20glowing%20underwater%20abyss%20with%20unknown%20creature%2C%20cinematic%20eerie%20deep%20blue%20tones&width=1600&height=900&seq=anime-hero-19&orientation=landscape",
    category: "悬疑",
    region: "日本",
    year: 2023,
    status: "连载",
    rating: 8.7,
    heat: 57600,
    episodes: 14,
    updatedAt: "2026-10-06",
    summary:
      "深海考察队在万米海沟发现无法解释的信号，一场关于未知与恐惧的探索就此展开。氛围营造极其出色。",
    tags: ["悬疑", "科幻", "冒险"],
  },
  {
    id: "anime-20",
    title: "猫猫日常",
    cover:
      "https://readdy.ai/api/search-image?query=cute%20anime%20cat%20lounging%20in%20a%20sunlit%20room%20with%20plants%2C%20adorable%20cozy%20slice%20of%20life%2C%20soft%20pastel%20colors%2C%20simple%20bright%20interior%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-20&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20cute%20key%20visual%20of%20cats%20in%20sunlit%20cozy%20home%2C%20cinematic%20soft%20pastel%20pleasant%20atmosphere&width=1600&height=900&seq=anime-hero-20&orientation=landscape",
    category: "日常",
    region: "日本",
    year: 2021,
    status: "完结",
    rating: 8.2,
    heat: 38700,
    episodes: 12,
    updatedAt: "2026-09-22",
    summary:
      "一只橘猫和它的人类室友的搞笑日常，每一集都是小小的快乐。轻松搞笑，治愈指数五颗星。",
    tags: ["日常", "搞笑", "治愈"],
  },
  {
    id: "anime-21",
    title: "王者之路",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20martial%20artist%20king%20with%20crown%20and%20glowing%20fists%2C%20powerful%20aura%2C%20korean%20manhwa%20style%2C%20bold%20vibrant%20colors%2C%20simple%20dramatic%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-21&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20martial%20arts%20key%20visual%20of%20king%20figure%20with%20glowing%20aura%2C%20cinematic%20bold%20dramatic%20composition%2C%20warm%20golden%20tones&width=1600&height=900&seq=anime-hero-21&orientation=landscape",
    category: "热血",
    region: "韩国",
    year: 2022,
    status: "连载",
    rating: 9.0,
    heat: 71300,
    episodes: 20,
    updatedAt: "2026-10-10",
    summary:
      "昔日的武术天才跌落谷底，为了重回巅峰踏上挑战强者的旅途。爽快直接的战斗节奏，看得停不下来。",
    tags: ["热血", "格斗", "成长"],
  },
  {
    id: "anime-22",
    title: "时光旅人",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20time%20traveler%20stepping%20through%20a%20glowing%20portal%20of%20clocks%20and%20light%2C%20surreal%20sci-fi%2C%20mystical%20mood%2C%20simple%20cosmic%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-22&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20time%20travel%20key%20visual%20of%20glowing%20portals%20and%20clocks%2C%20cinematic%20surreal%20composition%2C%20mystical%20cool%20tones&width=1600&height=900&seq=anime-hero-22&orientation=landscape",
    category: "科幻",
    region: "日本",
    year: 2018,
    status: "完结",
    rating: 8.9,
    heat: 62800,
    episodes: 13,
    updatedAt: "2026-09-18",
    summary:
      "一位少年意外获得穿越时间的能力，为了挽救重要的记忆不断回到过去。烧脑又催泪的科幻佳作。",
    tags: ["科幻", "悬疑", "催泪"],
  },
  {
    id: "anime-23",
    title: "花与剑",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20knight%20holding%20a%20sword%20surrounded%20by%20blooming%20flowers%2C%20romantic%20fantasy%2C%20elegant%20mood%2C%20soft%20colors%2C%20simple%20blossom%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-23&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20romantic%20fantasy%20key%20visual%20of%20knight%20in%20flower%20field%2C%20cinematic%20elegant%20soft%20tones%2C%20dreamy%20atmosphere&width=1600&height=900&seq=anime-hero-23&orientation=landscape",
    category: "恋爱",
    region: "日本",
    year: 2024,
    status: "连载",
    rating: 8.6,
    heat: 54100,
    episodes: 16,
    updatedAt: "2026-10-09",
    summary:
      "誓死守护公主的骑士，在战火间隙里藏着一份不敢说出口的心意。骑士与花的浪漫幻想物语。",
    tags: ["恋爱", "奇幻", "浪漫"],
  },
  {
    id: "anime-24",
    title: "英雄学院",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20superhero%20student%20with%20glowing%20power%20aura%20in%20school%20uniform%2C%20heroic%20pose%2C%20energetic%20colors%2C%20simple%20heroic%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-24&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20superhero%20academy%20key%20visual%20with%20students%20and%20glowing%20auras%2C%20cinematic%20energetic%20composition%2C%20warm%20heroic%20tones&width=1600&height=900&seq=anime-hero-24&orientation=landscape",
    category: "校园",
    region: "日本",
    year: 2020,
    status: "连载",
    rating: 9.2,
    heat: 88400,
    episodes: 26,
    updatedAt: "2026-10-12",
    summary:
      "在超能力者遍布的时代，一群怀揣英雄梦想的少年进入顶级英雄学院。成长、友情与正义的经典少年漫改编。",
    tags: ["校园", "热血", "超能力"],
  },
  {
    id: "anime-25",
    title: "火焰之拳",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20boxer%20with%20glowing%20fists%20throwing%20a%20powerful%20punch%20in%20a%20ring%2C%20dynamic%20action%20pose%2C%20intense%20energy%2C%20bold%20warm%20colors%2C%20simple%20arena%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-25&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20boxing%20key%20visual%20of%20fighter%20with%20glowing%20fists%2C%20cinematic%20dramatic%20composition%2C%20warm%20lighting%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-25&orientation=landscape",
    category: "热血",
    region: "日本",
    year: 2022,
    status: "完结",
    rating: 9.1,
    heat: 76500,
    episodes: 24,
    updatedAt: "2026-09-27",
    summary: "天赋平平的少年凭着不服输的信念走上拳台，一次次被打倒又一次次站起。汗水与荣耀交织的热血成长物语。",
    tags: ["热血", "格斗", "成长"],
  },
  {
    id: "anime-26",
    title: "星空下的约定",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20couple%20standing%20under%20a%20vast%20starry%20night%20sky%20on%20a%20hilltop%2C%20romantic%20tender%20mood%2C%20soft%20blue%20and%20pink%20tones%2C%20simple%20star%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-26&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20romantic%20key%20visual%20of%20couple%20under%20starry%20sky%2C%20cinematic%20dreamy%20composition%2C%20cool%20blue%20tones%2C%20gentle%20mood&width=1600&height=900&seq=anime-hero-26&orientation=landscape",
    category: "恋爱",
    region: "日本",
    year: 2023,
    status: "连载",
    rating: 8.5,
    heat: 43900,
    episodes: 12,
    updatedAt: "2026-10-03",
    summary: "天文社的两人因为一场流星雨相识相知，在星空下许下贯穿青春岁月的约定。清新浪漫的纯爱故事。",
    tags: ["恋爱", "青春", "治愈"],
  },
  {
    id: "anime-27",
    title: "未来都市",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20futuristic%20city%20with%20flying%20cars%20and%20glowing%20skyscrapers%2C%20cyberpunk%20sci-fi%20mood%2C%20neon%20colors%2C%20simple%20urban%20night%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-27&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20cyberpunk%20key%20visual%20of%20futuristic%20city%20skyline%20at%20night%2C%20cinematic%20neon%20composition%2C%20cool%20bright%20colors&width=1600&height=900&seq=anime-hero-27&orientation=landscape",
    category: "科幻",
    region: "中国",
    year: 2024,
    status: "连载",
    rating: 8.9,
    heat: 68200,
    episodes: 16,
    updatedAt: "2026-10-12",
    summary: "在高度智能化的未来都市，一名普通程序员意外发现了能改写现实的神秘代码。悬疑与科幻交织的烧脑之旅。",
    tags: ["科幻", "都市", "悬疑"],
  },
  {
    id: "anime-28",
    title: "精灵物语",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20girl%20companion%20with%20glowing%20wings%20and%20floating%20spirits%20in%20an%20enchanted%20forest%2C%20magical%20fantasy%2C%20vibrant%20colors%2C%20simple%20glowing%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-28&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20fantasy%20key%20visual%20of%20winged%20spirit%20girl%20in%20enchanted%20forest%2C%20cinematic%20magical%20composition%2C%20warm%20glow%2C%20dreamy&width=1600&height=900&seq=anime-hero-28&orientation=landscape",
    category: "奇幻",
    region: "日本",
    year: 2021,
    status: "完结",
    rating: 8.7,
    heat: 55700,
    episodes: 24,
    updatedAt: "2026-09-16",
    summary: "被选中的少女与守护她的精灵伙伴一同踏上旅途，寻找失落的世界之树。温暖又充满想象的幻想物语。",
    tags: ["奇幻", "冒险", "治愈"],
  },
  {
    id: "anime-29",
    title: "甜品小铺",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20girl%20baking%20colorful%20desserts%20in%20a%20cozy%20sweet%20shop%2C%20warm%20slice%20of%20life%2C%20soft%20pastel%20colors%2C%20simple%20shop%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-29&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20slice%20of%20life%20key%20visual%20of%20cozy%20dessert%20shop%20with%20pastel%20sweets%2C%20cinematic%20warm%20soft%20light%2C%20pleasant%20atmosphere&width=1600&height=900&seq=anime-hero-29&orientation=landscape",
    category: "日常",
    region: "日本",
    year: 2024,
    status: "连载",
    rating: 8.1,
    heat: 36400,
    episodes: 10,
    updatedAt: "2026-10-08",
    summary: "年轻店主独自经营一家街角甜品铺，用一份份甜点为客人带来小小的幸福。治愈满分的温馨日常。",
    tags: ["日常", "美食", "治愈"],
  },
  {
    id: "anime-30",
    title: "足球风云",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20soccer%20player%20kicking%20the%20ball%20mid%20action%20on%20a%20bright%20field%2C%20dynamic%20sports%20pose%2C%20vibrant%20green%20colors%2C%20simple%20stadium%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-30&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20soccer%20key%20visual%20of%20player%20scoring%20under%20stadium%20lights%2C%20cinematic%20dynamic%20composition%2C%20vibrant%20colors&width=1600&height=900&seq=anime-hero-30&orientation=landscape",
    category: "运动",
    region: "日本",
    year: 2021,
    status: "完结",
    rating: 8.6,
    heat: 49800,
    episodes: 24,
    updatedAt: "2026-09-14",
    summary: "一支濒临解散的校园足球队，在新教练的带领下重新找回斗志，向着全国大赛发起冲击。",
    tags: ["运动", "热血", "团队"],
  },
  {
    id: "anime-31",
    title: "机械战警",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20armored%20cyborg%20hero%20with%20glowing%20visor%20in%20a%20high%20tech%20city%2C%20sci-fi%20action%2C%20cool%20metallic%20colors%2C%20simple%20urban%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-31&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20mecha%20cyborg%20key%20visual%20in%20futuristic%20city%2C%20cinematic%20action%20composition%2C%20cool%20metallic%20tones%2C%20dark%20edges&width=1600&height=900&seq=anime-hero-31&orientation=landscape",
    category: "机战",
    region: "美国",
    year: 2023,
    status: "完结",
    rating: 8.4,
    heat: 44200,
    episodes: 12,
    updatedAt: "2026-09-12",
    summary: "一次意外让警官与机械装甲融为一体，他必须在守护城市与坚守人性之间做出选择。硬核科幻动作之作。",
    tags: ["机战", "科幻", "动作"],
  },
  {
    id: "anime-32",
    title: "暗夜追凶",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20detective%20with%20flashlight%20in%20a%20dark%20rainy%20alley%2C%20tense%20mystery%20mood%2C%20moody%20cool%20colors%2C%20simple%20dark%20street%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-32&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20crime%20mystery%20key%20visual%20of%20rainy%20dark%20city%20alley%20with%20detective%2C%20cinematic%20tense%20composition%2C%20cool%20dark%20tones&width=1600&height=900&seq=anime-hero-32&orientation=landscape",
    category: "悬疑",
    region: "中国",
    year: 2024,
    status: "连载",
    rating: 9.0,
    heat: 70100,
    episodes: 15,
    updatedAt: "2026-10-11",
    summary: "一系列看似无关的案件背后隐藏着同一个秘密，刑警队长抽丝剥茧逼近真相。节奏紧凑的国产悬疑力作。",
    tags: ["悬疑", "推理", "刑侦"],
  },
  {
    id: "anime-33",
    title: "笑傲江湖传",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20wandering%20swordsman%20playing%20a%20flute%20on%20a%20mountain%20cliff%20at%20dusk%2C%20chinese%20wuxia%20classic%20style%2C%20warm%20sunset%20colors%2C%20simple%20ink%20mountain%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-33&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20chinese%20wuxia%20anime%20key%20visual%20of%20swordsman%20on%20misty%20mountain%20cliff%20at%20sunset%2C%20cinematic%20classic%20composition%2C%20warm%20tones&width=1600&height=900&seq=anime-hero-33&orientation=landscape",
    category: "经典",
    region: "中国",
    year: 1996,
    status: "完结",
    rating: 9.6,
    heat: 92300,
    episodes: 40,
    updatedAt: "2026-09-10",
    summary: "江湖恩怨、儿女情长与家国大义交织的武侠经典，历经岁月依旧荡气回肠，是无数观众心中的永恒记忆。",
    tags: ["经典", "武侠", "国风"],
  },
  {
    id: "anime-34",
    title: "校园乐队",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20high%20school%20band%20members%20performing%20with%20guitars%20and%20drums%20on%20stage%2C%20energetic%20youth%20music%20mood%2C%20vibrant%20stage%20colors%2C%20simple%20concert%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-34&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20music%20key%20visual%20of%20school%20band%20performing%20under%20stage%20lights%2C%20cinematic%20energetic%20composition%2C%20vibrant%20colors&width=1600&height=900&seq=anime-hero-34&orientation=landscape",
    category: "校园",
    region: "日本",
    year: 2023,
    status: "连载",
    rating: 8.3,
    heat: 41500,
    episodes: 12,
    updatedAt: "2026-10-05",
    summary: "几个性格迥异的学生为了不让音乐社团被解散而组建乐队，用音乐谱写属于青春的最强音。",
    tags: ["校园", "音乐", "青春"],
  },
  {
    id: "anime-35",
    title: "宇宙漂流",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20lone%20astronaut%20drifting%20in%20space%20amid%20debris%20and%20glowing%20stars%2C%20lonely%20sci-fi%20mood%2C%20cool%20deep%20blue%20tones%2C%20simple%20space%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-35&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20sci-fi%20key%20visual%20of%20astronaut%20adrift%20among%20stars%20and%20debris%2C%20cinematic%20lonely%20composition%2C%20cool%20deep%20blue%20tones&width=1600&height=900&seq=anime-hero-35&orientation=landscape",
    category: "科幻",
    region: "日本",
    year: 2020,
    status: "完结",
    rating: 8.8,
    heat: 58600,
    episodes: 13,
    updatedAt: "2026-09-08",
    summary: "一场事故让宇航员与地球失去联系，独自漂流的他在浩瀚宇宙中重新思考生命的意义。安静而深邃的科幻小品。",
    tags: ["科幻", "宇宙", "治愈"],
  },
  {
    id: "anime-36",
    title: "心跳的信号",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20shy%20girl%20and%20boy%20exchanging%20a%20nervous%20glance%20in%20a%20sunlit%20classroom%2C%20sweet%20romantic%20mood%2C%20warm%20soft%20colors%2C%20simple%20classroom%20background%2C%20high%20detail%20anime%20illustration&width=600&height=800&seq=anime-cover-36&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20widescreen%20anime%20romance%20key%20visual%20of%20shy%20students%20in%20sunlit%20classroom%2C%20cinematic%20sweet%20composition%2C%20warm%20soft%20light&width=1600&height=900&seq=anime-hero-36&orientation=landscape",
    category: "恋爱",
    region: "日本",
    year: 2022,
    status: "完结",
    rating: 8.4,
    heat: 45200,
    episodes: 12,
    updatedAt: "2026-09-06",
    summary: "一封没有署名的信让两个内向的人开始留意彼此，笨拙又真诚的靠近，藏着青春期最甜的心跳。",
    tags: ["恋爱", "校园", "治愈"],
  },
];

export const categories: AnimeCategory[] = [
  { id: "hotblood", name: "热血", description: "燃到爆表的战斗与成长，少年们的热血传说。", icon: "ri-fire-line", color: "primary" },
  { id: "campus", name: "校园", description: "青春校园里的友情、梦想与悸动。", icon: "ri-building-2-line", color: "accent" },
  { id: "scifi", name: "科幻", description: "星辰大海与未来科技，想象力没有边界。", icon: "ri-rocket-2-line", color: "secondary" },
  { id: "fantasy", name: "奇幻", description: "魔法、冒险与异世界，一场梦幻之旅。", icon: "ri-magic-line", color: "primary" },
  { id: "romance", name: "恋爱", description: "心跳加速的甜蜜物语，温柔又治愈。", icon: "ri-heart-3-line", color: "accent" },
  { id: "daily", name: "日常", description: "琐碎日常里的小确幸，慢慢看很舒服。", icon: "ri-cup-line", color: "secondary" },
  { id: "sports", name: "运动", description: "汗水、默契与逆转，竞技场上的青春。", icon: "ri-basketball-line", color: "primary" },
  { id: "mecha", name: "机战", description: "钢铁巨兽的咆哮，硬核机甲的对决。", icon: "ri-robot-2-line", color: "secondary" },
  { id: "mystery", name: "悬疑", description: "层层谜团与反转，追到停不下来。", icon: "ri-search-eye-line", color: "accent" },
  { id: "classic", name: "经典", description: "跨越时间依然闪光的动画瑰宝。", icon: "ri-bookmark-3-line", color: "primary" },
];

export const regions: string[] = ["全部", "日本", "中国", "美国", "韩国"];

export const years: string[] = ["全部", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "1996", "1988"];

export const sortOptions: { value: string; label: string }[] = [
  { value: "update", label: "按更新时间" },
  { value: "heat", label: "按热度" },
  { value: "rating", label: "按评分" },
];

export const heroAnimeIds: string[] = ["anime-01", "anime-14", "anime-08", "anime-04", "anime-24"];